import {
  AddOutlined,
  ArrowBackOutlined,
  DeleteOutline,
  EditOutlined,
  RefreshOutlined,
} from "@material-ui/icons";
import {
  Box,
  Button,
  CardHeader,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { frFR } from "@mui/x-data-grid/locales";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import SearchIcon from "@mui/icons-material/Search";
import useToast from "../../../../../../hooks/useToast";
import useConfirm from "../../../../../../hooks/useConfirm";
import { useQuery } from "../../../../../../hooks/useQuery";
import { TYPE_NOTIFICATION } from "../../../../shares/NotificationBull";
import { DomaineParAMIService } from "../../../../../../service/DomaineParAMIService";
import { SQCFormulaireService } from "../../../../../../service/SQC_form/SQCFormulaireService";
import SousDomaineForm from "./SousDomaineForm";
import { SousDomaineService } from "../../../../../../service/SousDomaineService";

const SousDomaineList = ({ selection = false }) => {
  const [formulaireList, setFormulaireList] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const navigate = useNavigate();
  const [filtre, setFiltre] = useState({});
  const { Toast, showToast } = useToast();
  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [idSelectedForm, setIdSelectedForm] = useState(null);
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const [openDialogForm, setOpenDialogForm] = useState(false);
  const [selectedSousDomaineID, setSelectedSousDomaineID] = useState(null);
  const url = useQuery();
  const id_type = url.get("ref");

  const handleGoBack = () => {
    navigate(-1);
  };
  const handleFetchDomaineList = () => {
    setDataLoading(true);
    SousDomaineService.lister({ ...filtre, id__domaine: url.get("dom") })
      .then((res) => {
        if (res && res.data) {
          setFormulaireList(res.data);
          setFilteredRows(res.data);
        } else {
          setFormulaireList([]);
          setFilteredRows([]);
        }
      })
      .finally(() => {
        setDataLoading(false);
      });
  };

  const handleDeleteRow = (id) => {
    openConfirmDialog(
      "Confirmation",
      "Voullez vous supprimer cette ligne?",
      () => {
        handleConfirmDeleteRow(id);
      }
    );
  };

  const handleConfirmDeleteRow = (id) => {
    SQCFormulaireService.delete(id).then((res) => {
      if (res && res.success) {
        showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
        handleFetchDomaineList();
      } else {
        showToast(TYPE_NOTIFICATION.ERROR, res.message);
      }
    });
  };

  const handleOpenDialogForm = (idForm) => {
    setOpenFormDialog(true);
    setIdSelectedForm(idForm);
  };

  const handleCloseDialogForm = () => {
    setOpenFormDialog(false);
    handleFetchDomaineList();
  };

  const handleFilter = (filtre) => {
    if (!filtre || String(filtre).trim() === "") {
      setFilteredRows(formulaireList);
      return;
    }
    const mots = filtre
      .toLowerCase()
      .split(" ")
      .filter((mot) => mot.trim() !== "");
    setFilteredRows(
      formulaireList.filter((item) =>
        mots.every((mot) =>
          Object.values(item).some(
            (val) => val && val.toString().toLowerCase().includes(mot)
          )
        )
      )
    );
  };

  const table_colonne = [
    {
      field: "name",
      headerName: "Sous domaine",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "description",
      headerName: "Description du domaine",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "action",
      headerName: "Actions",
      minWidth: 180,
      renderCell: (params) => {
        return (
          <Grid>
            <IconButton
              title="Parametrer questions"
              color="primary"
              // onClick={(e) =>
              //   handleShowQuestionList(params.row.ext_sqc_form_id)
              // }
            >
              <SettingsOutlinedIcon />
            </IconButton>
            <IconButton
              title="Modifier formulaire"
              color="secondary"
               onClick={(e) => handleOpenSousDomaineDialog(params.row.id_sous_domaine)}
            >
              <EditOutlined />
            </IconButton>
            <IconButton
              title="Supprimer formulaire"
              color="warning"
              onClick={(e) => handleDeleteSousDomaine(params.row)}
            >
              <DeleteOutline />
            </IconButton>
          </Grid>
        );
      },
    },
  ];

  const handleOpenSousDomaineDialog = (id_sous_domaine) => {
    setSelectedSousDomaineID(id_sous_domaine);
    setOpenFormDialog(true);
  };

  const handleCloseSousDomaineDialog = () => {
    setSelectedSousDomaineID(null);
    setOpenFormDialog(false);
    handleFetchDomaineList();
  }

  const handleDeleteSousDomaine = (row) => {
    openConfirmDialog(
      "Confirmation",
      "Voullez vous supprimer cette ligne?",
      () => {
        handleConfirmDeleteSousDomaine(row);
      }
    );
  }

  const handleConfirmDeleteSousDomaine = (row) => {
    SousDomaineService.delete(row).then((res) => {
      if (res && res.success) {
        showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
        handleFetchDomaineList();
      } else {
        showToast(TYPE_NOTIFICATION.ERROR, res.message);
      }
    });
  }

  useEffect(() => {
    handleFetchDomaineList();
  }, []);

  return (
    <>
      <SousDomaineForm
        idForm={url.get("ref")}
        open={openFormDialog}
        onFormClose={(e) => handleCloseSousDomaineDialog()}
        idSousDomaine={selectedSousDomaineID}
      />
      <DialogComponent />
      <Toast />
      <Grid width={"100%"}>
        <Paper elevation={0}>
          <Grid>
            <CardHeader
              title="Les sous domaines"
              titleTypographyProps={{ variant: "h5" }}
              avatar={
                <Button onClick={handleGoBack}>
                  <ArrowBackOutlined />
                </Button>
              }
              action={
                <Grid container spacing={2} justifyContent="space-around">
                  <Grid item>
                    <TextField
                      id="recherche"
                      fullWidth
                      size="small"
                      onChange={(e) => handleFilter(e.target.value)}
                      placeholder="Recherche"
                      InputProps={{
                        endAdornment: (
                          <IconButton>
                            <SearchIcon />
                          </IconButton>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <IconButton
                      title="Actualiser"
                      color="primary"
                      onClick={handleFetchDomaineList}
                    >
                      <RefreshOutlined />
                    </IconButton>
                  </Grid>
                  <Grid item>
                    <IconButton
                      onClick={(e) => handleOpenSousDomaineDialog(null)}
                      color="primary"
                      title="Creer une formulaire"
                    >
                      <AddOutlined />
                    </IconButton>
                  </Grid>
                </Grid>
              }
            />
            <Grid container>
              <Box display={dataLoading ? "" : "none"} sx={{ width: "100%" }}>
                <LinearProgress />
              </Box>
              <DataGrid
                sx={{
                  width: {
                    xs: "75.5vw",
                    sm: "90vw",
                    md: "93.5vw",
                    lg: "79.5vw",
                    height: "60vh",
                  },
                }}
                columns={table_colonne}
                // rows={formulaireList}
                rows={filteredRows}
                getRowId={(row) => row.id_sous_domaine}
                localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  );
};

export default SousDomaineList;
